import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BrandingService, ObjectHelper } from 'common';
import { AppSettings } from 'projects/portal/src/app.settings';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class UserPasswordResetGuard implements CanActivate {

  constructor(
    private appSettings: AppSettings,
    private brandingService: BrandingService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const queryParamsString = ObjectHelper.getQueryParams(route.queryParams);

    this.brandingService.getBranding().pipe(untilDestroyed(this)).subscribe(branding => {
      window.location.href = branding?.loginUrl + this.appSettings.auth.resetPassword + (queryParamsString ? `?${queryParamsString}` : '');
    })
    return true;
  }
}
